module.exports = __webpack_public_path__ + "img/logo4.eb862f6b.png";